if (!customElements.get('multi-tabs')) {
  customElements.define(
    'multi-tabs',
    class Onglets extends HTMLElement {
      constructor() {
        super();
        this.tabButtons = [];
        this.tabContents = [];
      }

      connectedCallback() {
        this.tabButtons = this.querySelectorAll('.tabs-slider__tab-button');
        this.tabContents = this.querySelectorAll('.tabs-slider__content');

        this.tabButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const index = button.getAttribute('data-index');

            this.tabButtons.forEach((btn) => btn.classList.remove('active'));
            this.tabContents.forEach((content) => {
              content.classList.remove('active');
              content.style.display = 'none';
            });

            button.classList.add('active');
            const targetContent = this.querySelector(`.tabs-slider__content[data-index="${index}"]`);
            if (targetContent) {
              targetContent.classList.add('active');
              targetContent.style.display = 'block';

              targetContent.style.animation = 'none';
              setTimeout(() => {
                targetContent.style.animation = 'slideEffect 0.5s ease';
              }, 10);
            }
          });
        });
      }
    }
  );
}
